import Vue from 'vue'
import { Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import { Item, InputRow, Node } from "../models";
import FormRows from "../parts/FormRows";
import App from '../App'
import { shuffle, sleep, normalizeModel, bakeRemoteData } from '../utils'
import SelectNode from '../parts/SelectNode'
import { remoteOp } from "../helper";

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  model: {[k: string]: any};
  modified: boolean;
}

type State = UnsetState | ErrorState | DoneState


const confirmMsg = '表单已被修改, 是否放弃保存?'

@Component({
  name: 'PortalNodeUpdate',
  components: { FormRows },

  beforeRouteUpdate(this: PortalNodeUpdate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  },

  beforeRouteLeave(this: PortalNodeUpdate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  }
})
export default class PortalNodeUpdate extends Vue {
  @Prop() callbacks: {
    append: (data) => void;
    update: (data) => void;
  }

  @Prop() node: Node;

  busy = false

  id = 0

  get inputs(): InputRow[] {
    let types = (this.$root.$children[0] as App).availableNodeTypes
    let typeOptions = types.map(v => ({value: v, text: v}))
    typeOptions.unshift({value: 'jump', text: '[ jump ]'})
    typeOptions.unshift({value: 'none', text: '[ none ]'})
    return [
      { widget: 'text', key: 'name', label: '名称' },
      { widget: 'select', key: 'type', label: '类型', values:  typeOptions},
      { widget: 'text', key: 'alias', label: 'alias' },
      { widget: 'text', key: 'class_list', label: 'class' },
      { widget: 'text', key: 'link', label: '重定向' },
      { widget: 'checkbox', key: 'need_login', label: '需登录' },
      { widget: 'text', key: 'tpl_index', label: '页面模板' },
      { widget: 'text', key: 'tpl_item', label: '项目模板' },
    ]
  }

  private _unwatch?: (()=>void)

  created() {
    this.reset()
  }

  state: State = {kind: 'unset'}

  loading = false

  get status() {
    return this.state.kind
  }

  get modified() {
    return this.state.kind === 'done'
        && this.state.modified
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.name === 'portal-node-update') {
      this.reset()
    }
  }

  beforeDestroy() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
  }

  private async reset() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
    this.busy = false
    this.loading = true
    let childId = parseInt(this.$route.params.childId)
    let child = this.node.children.find(n => n.id === childId)
    if (child) {
      this.id = childId
      let portalKey = this.$route.params.portalKey
      let result=  await api.node.get(childId, portalKey, 0)
      this.state = {
        kind: 'done',
        model: {
          name: result.name,
          type: result.type,
          alias: result.alias,
          class_list: result.class_list,
          link: result.link,
          need_login: result.need_login,
          tpl_index: result.tpl_index,
          tpl_item: result.tpl_item,
        },
        modified: false
      }
      this.loading = false
      let state = this.state
      this._unwatch = this.$watch('state.model', (oldValue, newValue) => {
        if (newValue && oldValue && newValue === oldValue)
          state.modified = true
      }, {deep: true})
    }
  }

  save() {
    if (this.state.kind !== 'done') {
      return
    }
    if (!this.modified) {
      if (!confirm('表单似乎未被修改, 是否继续?')) {
        return
      }
    }
    if (!this.state.model.name) {
      alert('请填写节点名称')
      return
    }
    if (!this.state.model.type) {
      alert('请填写节点类型')
      return
    }
    if (!this.id) {
      return
    }
    $(':focus', this.$el).blur()
    let data = bakeRemoteData(this.state.model, this.inputs)
    data.parent_id = parseInt(this.$route.params.nodeId)
    let state = this.state
    remoteOp(this, '保存', '节点', async () => {
      let result = await api.node.update(this.id, data)
      state.modified = false
      this.close()
      data.id = this.id
      this.callbacks.update(data)
    })
  }

  close() {
    this.$router.replace({ name: 'portal-node-list' })
  }
}


